/*
 * @Description: 
 * @Author: 李方强
 * @Date: 2019-07-25 16:12:31
 * @LastEditTime: 2021-04-02 10:34:22
 * @LastEditors: lkz
 */
import Vue from 'vue'
import Router from 'vue-router'
import baseRouter from './router-base'
import errorRouter from './router-error'
import exampleRouter from './router-example'
import workRouter from './router-work'
import configurationCenterRouter from './router-configuration-center'
import sessionRouter from './router-session'
import knowledgeBase from './router-knowledgeBase'
import sopRouter from './router-sop'
import monitorRouter from './router-monitor'
import workOrderManagementRouter from './router-workOrderManagement'
import sendSms from './router-sendSms'
import robot from './router-robot'
import intellectQuality from './router-intellectQuality'
import log from './router-log'
import workUnlock from './router-workUnlock'
import voucher from './router-voucher'
import taskManagement from './router-taskManagement'
import loginrouter from './router-login'
import juridistionrouter from './router-juridistion'
import workMenu from './router-workMenu'
import businessKnowledge from './router-businessKnowledge'
import nb from './router-newbusiness'
import mini from './router-robotConfig'
import eventlist from './router-eventlist'
import customerRisk from './router-customerRisk'
import Woqu from './router-woqu'
import Hotpoint from './router-hotpoint'
import messageQuery from './router-messageQuery'

/*
  路由一般定义为三个部分：
    常规路由（router-base)：提供顶级的路由，通常为常用的路由、不需要按需加载的路由等等，保持最多20个路由，否则移入到模块路由
    异常路由（router-error）：提供各种异常，比如500, 404, 402(无权限）
    模块路由（router-modulename)：提供项目模块相关的路由，例如router-shops路由等等
*/

Vue.use(Router)

export default new Router({
  base: '/xinyunweb',
  mode: 'history',
  routes: [
    ...baseRouter,
    ...workRouter,
    ...configurationCenterRouter,
    ...exampleRouter,
    ...sessionRouter,
    ...knowledgeBase,
    ...sopRouter,
    ...monitorRouter,
    ...workOrderManagementRouter,
    ...sendSms,
    ...robot,
    ...intellectQuality,
    ...log,
    ...workUnlock,
    ...voucher,
    ...taskManagement,
    ...loginrouter,
    ...juridistionrouter,
    ...workMenu,
    ...businessKnowledge,
    ...nb,
    ...mini,
    ...eventlist,
    ...customerRisk,
    ...Woqu,
    ...Hotpoint,
    ...messageQuery,
    ...errorRouter
  ]
})
